import React, { useState } from 'react';
import commonUtil from '../../common/commonUtil';
import thanks_logo from '../../resources_membership_hotel/image/thanks_logo.gif';
import { Button } from '../atoms/button';

export const PlanList = (props) => {
    const { facilityListWrapperName,
        planListWrapperName,
        planWrapperName,
        facilityList,
        isWideTablet,
        planListStyle,
        facilityImgStyle,
        handlePlanDetail,
        handleReserve,
        handleReserveMachi,
        handleErrorFacility,
        membershipFacility,
        handleErrorPlan,
        handleOpenFee,
        getPlanShohinCount,
        changePlanFlg,
        checkIn,
        checkOut,
        crawlMachiFlg
    } = props;
    let buttonText = '';

    const [displayAllPlanFlg, setDisplayAllPlanFlg] = useState({});
    const handleAllPlan = (index) => {
        const newState = {
            ...displayAllPlanFlg,
        };
        newState[index] = !newState[index];
        setDisplayAllPlanFlg(newState);
    }
    const getPlanDisplay = (plan,facility) => {
      const ippanFacilityList = []
      
      if (!changePlanFlg) {
          if (!membershipFacility) return ''
          membershipFacility.ippan.forEach((data) => {
            if (data.shisetsuList) {
              data.shisetsuList.forEach(item => {
                if (item.checked) ippanFacilityList.push(item.id)
              })
            }
          })
          // TLであれば部屋情報を表示する
          if (ippanFacilityList.includes(facility.shisetsuCd)) {
            return (<div>{plan.planName}</div>)
          }
      }

      return (<div>
        <div>
          {plan.dinnerRyokinAdult ? "夕食" + Number(plan.dinnerRyokinAdult).toLocaleString() + "円" : ""}
          {plan.dinnerRyokinAdult && plan.breakfastTsukiPlanFlg ? "・" : ""}
          {plan.breakfastTsukiPlanFlg ? "朝食付き" : ""}
        </div>
        <div className="planFee" style={{ display: "flex", alignItems: "center" }}>
          <div style={styles.feeLabel}>
            人数合計
          </div>
          <div style={styles.fee}>
              ¥{Number(plan.planRyokinTotal).toLocaleString()}～
          </div>
        </div>
      </div>)
    }

    const checkMachiKbn = (flKirikaeDat) => {
        const checkInBaseDate = commonUtil.getDateFromString(flKirikaeDat, "-");
        let checkOutBaseDate = new Date(checkInBaseDate);
        checkOutBaseDate.setDate(checkOutBaseDate.getDate() + 1);
        const result = commonUtil.getDateFromString(checkIn, "-") <= checkInBaseDate && commonUtil.getDateFromString(checkOut, "-") <= checkOutBaseDate;
        return result;
    }

    // プラン商品
    const planContents = (facility, planShohin, facilityIndex, planShohinIndex) => {
        let planWrapperClass = planShohin.planList && planShohin.planList[0] && planShohin.planList[0].machiFlg == "0" ? planWrapperName : "hiddenItem";
        return <div key={planShohin.planShohinCd} className={planWrapperClass}>
            <img
                src={facility.shisetsuImage}
                style={{ display: "none" }}
            onError={e => {
                e.target.parentElement.style.display = "none";
                handleErrorPlan(facility.shisetsuCd, planShohin.planShohinCd);
            }}
            />
            {/* 朝食・夕食なしの場合 */}
            <div className={planShohin.planList && planShohin.planList[0] &&
                !planShohin.planList[0].dinnerTsukiPlanFlg && !planShohin.planList[0].breakfastTsukiPlanFlg ?
                isWideTablet ? "planProductMobile" : "planProductWithoutMeal" : "hiddenItem"}>
                <div className="membershipWithoutMealPlanName">
                    {planShohin.planShohinName}
                    <img
                        src={thanks_logo}
                        style={planShohin.planList && planShohin.planList.filter(value => value.thanksFlg).length != 0 ? { height: "40px" } : { display: "none" }}
                    />
                </div>
                {/* プラン */}
                <div>
                    <div className="membershipPlanBtnArea">
                        <Button
                            wrapClassName="planDetailWrapLong"
                            className={isWideTablet ? "planDetailBtnMobile" : "planDetailBtnWithoutMealPlan"}
                            onClick={() => handlePlanDetail(facility, planShohin, planShohin.planList && planShohin.planList[0] ? planShohin.planList[0] : {})}
                            buttonText={"プラン詳細"}
                            buttonClassName="serachBtnText"
                            tabIndex="17"
                        />
                        <Button
                            buttonText={"予約する"}
                            className={"membershipApplyBtn"}
                            onClick={() => handleReserve(facility, planShohin, planShohin.planList && planShohin.planList[0] ? planShohin.planList[0] : {})}
                            buttonClassName="serachBtnText"
                            tabIndex="18"
                        />
                    </div>
                </div>
            </div>

            {/* 朝食・夕食付きの場合 */}
            <div className={planShohin.planList && planShohin.planList[0] &&
                !planShohin.planList[0].dinnerTsukiPlanFlg && !planShohin.planList[0].breakfastTsukiPlanFlg ? "hiddenItem" : ""}>
                <div className="membershipPlanName">
                    {planShohin.planShohinName}
                    <img
                        src={thanks_logo}
                        style={planShohin.planList && planShohin.planList.filter(value => value.thanksFlg).length != 0 ? { height: "40px" } : { display: "none" }}
                    />
                </div>
                {/* プラン */}
                {planShohin.planList && planShohin.openFlg ? planShohin.planList.map((plan, index) =>
                    <div>
                        <div className={isWideTablet ? "planProductMobile" : "planProduct"}>
                            <div>
                                <div>
                                    {getPlanDisplay(plan, facility)}
                                </div>
                            </div>
                            <div>
                                <div className="membershipPlanBtnArea">
                                    <Button
                                        wrapClassName="planDetailWrapLong"
                                        className={isWideTablet ? "planDetailBtnMobile" : "planDetailBtn"}
                                        onClick={() => handlePlanDetail(facility, planShohin, plan)}
                                        buttonText={"プラン詳細"}
                                        buttonClassName="serachBtnText"
                                        tabIndex="17"
                                    />
                                    <Button
                                        buttonText={"予約する"}
                                        className={"membershipApplyBtn"}
                                        onClick={() => handleReserve(facility, planShohin, plan)}
                                        buttonClassName="serachBtnText"
                                        tabIndex="18"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                <div className={"btnAllPlanWrap"}>
                    <Button
                        buttonText={planShohin.openFlg ? "詳細を閉じる" : "詳細を表示"}
                        className={planShohin.openFlg ? "closeFeeBtn" : "openFeeBtn"}
                        onClick={() => handleOpenFee(facilityIndex, planShohinIndex)}
                        buttonClassName="serachBtnText"
                    />
                </div>
            </div>
        </div>;
    }

    // 待ちボタン
    const displayMachiBtn = (facility) =>
        <div className={planListWrapperName}>
            <div style={styles.machiButtonArea}>
                <div className="membershipPlanBtnArea">
                    <Button
                        buttonText={facility?.flKirikaeDat && checkIn && checkOut ? checkMachiKbn(facility.flKirikaeDat) ? 'キャンセル待ちで申し込む' : '交換待ちで申し込む' : ""}
                        className="membershipApplyWaitBtn"
                        onClick={() => handleReserveMachi(facility, facility.planShohinList[0], facility.planShohinList[0].planList && facility.planShohinList[0].planList[0] ? facility.planShohinList[0].planList[0] : {})}
                        buttonClassName="serachBtnText"
                        tabIndex="18"
                    />
                </div>
                <div className="planProductLabel" style={styles.supplementText}>※レストランは希望となります</div>
            </div>
        </div>;

    // プラン一覧
    const displayDefaultArea = (facility, facilityIndex, planShohinCount) =>
        <>
            <div className={planShohinCount > 0 && !crawlMachiFlg ? planListWrapperName : "hiddenItem"}>
                <div className="planNumLabel" >プラン一覧（{planShohinCount}件）</div>

                {/* プラン商品 */}
                {displayAllPlanFlg[facilityIndex] || changePlanFlg ? facility.planShohinList.map((planShohin, index) => (planContents(facility, planShohin, facilityIndex, index)))
                    : facility.planShohinList?.filter(planShohin => planShohin?.planList?.[0]?.machiFlg == "0")
                        ?.filter((planShohin, planShohinIndex) => planShohinIndex < 2).map((planShohin, index) => (planContents(facility, planShohin, facilityIndex, index)))}
                {(displayAllPlanFlg[facilityIndex] || planShohinCount <= 2) && !changePlanFlg ? displayMachiBtn(facility) : null}
                {/* プラン一覧の開閉ボタン */}
                <div className={planShohinCount > 2 && !changePlanFlg ? "btnAllPlanWrap" : "hiddenItem"}>
                    <Button
                        buttonText={displayAllPlanFlg[facilityIndex] ? "プラン一覧を閉じる" : "すべてのプランを見る"}
                        className={displayAllPlanFlg[facilityIndex] ? "btnOmitPlan" : "btnAllPlan"}
                        onClick={() => handleAllPlan(facilityIndex)}
                        buttonClassName="serachBtnText"
                    />
                </div>
            </div>
            {(isMachiFacility(facility) && planShohinCount == 0) || crawlMachiFlg ? displayMachiBtn(facility) : null}
        </>

    return (
        <div style={planListStyle}>
            {facilityList.map((facility, facilityIndex) => (
                <div key={facility.shisetsuCd + facilityIndex} style={facility.planShohinList.length != 0 ? changePlanFlg ? null : { marginBottom: "40px" } : { display: "none" }}>
                    {/* 施設画像 */}
                    <div className={changePlanFlg ? "hiddenItem" : "shisetsuImageWrap"}>
                        <img
                            src={facility.shisetsuImage}
                            style={facilityImgStyle}
                            className="shisetsuImage"
                            onError={e => {
                                e.target.parentElement.style.display = "none";
                                handleErrorFacility(facilityIndex);
                            }}
                        />
                        <div className={facility.generalFlg ? "hiddenItem" : "planGradeWrapper"}>
                            <div className='planGradeLabel'>
                                空室のあるお部屋グレード
                            </div>
                            <div className='planGradeInfo'>
                                <div className={facility.machiFlgS == null ? 'hiddenItem' : facility.machiFlgS == 0 ? "planGrade" : "planGradeBooked"}>
                                    {facility.gradeNameS}
                                </div>
                                <div className={facility.machiFlgE == null ? 'hiddenItem' : facility.machiFlgE == 0 ? "planGrade" : "planGradeBooked"}>
                                    {facility.gradeNameE}
                                </div>
                                <div className={facility.machiFlgC == null ? 'hiddenItem' : facility.machiFlgC == 0 ? "planGrade" : "planGradeBooked"}>
                                    {facility.gradeNameC}
                                </div>
                                <div className={facility.machiFlgA == null ? 'hiddenItem' : facility.machiFlgA == 0 ? "planGrade" : "planGradeBooked"}>
                                    {facility.gradeNameA}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 施設名 */}
                    <div className={facilityListWrapperName}>
                        <div className="membershipFacilityName"> {facility.shisetsuName}</div>
                    </div>

                    {/* プラン一覧・待ちボタン */}
                    {displayDefaultArea(facility, facilityIndex, getPlanShohinCount(facility.planShohinList))}
                </div>
            ))
            }
        </div >
    );
}

// 施設申し込み状況が待ち状態か判定
const isMachiFacility = (facility) => {
    // 一般ホテルの場合は待ちなし
    if (facility.generalFlg) return false;

    // プラン商品を持たない場合は早期リターン
    if (!facility.planShohinList?.length) return false;

    // 待ちフラグが存在するかチェック
    let result = false;
    facility.planShohinList.forEach(planShohin => {
        planShohin.planList?.forEach(plan => {
            result = plan.machiFlg != '0';
            if (result) return;
        });
        if (result) return;
    });

    // 待ち状態判定結果を返す
    return result
}

const styles = {
    feeLabel: {
        whiteSpace: "nowrap",
        color: "gray",
        fontSize: "small",
        lineHeight: "1rem",
    },
    fee: {
        fontWeight: "bold",
        padding: "0px 16px",
        fontSize: "large",
        whiteSpace: "nowrap",
        lineHeight: "1rem",
    },
    machiButtonArea: {
        margin: "0 0 0 auto",
        width: "fit-content",
    },
    supplementText: {
        paddingLeft: "10px",
    }
}